import { isCEP, isCNPJ, isCPF, isPhone } from 'brazilian-values';

import { convertDateString } from './convertStringDate';
import { unmaskCEP } from './UnMaskCep';
import { unmaskCnpj } from './UnMaskCnpj';
import { unmaskCpf } from './UnMaskCpf';
import { unmaskMoney } from './UnMaskMoney';
import { unmaskPhoneNumber } from './UnMaskPhoneNumber';

const displayToDbValueMapping: { [key: string]: string } = {
  'Não solicitado': 'nao_solicitado',
  // Adicione outros mapeamentos conforme necessário
};

export function unmaskValues(value: string) {
  if (!value) return '';

  // Verifique se o valor tem um mapeamento correspondente
  if (displayToDbValueMapping[value]) {
    return displayToDbValueMapping[value];
  }

  switch (true) {
    case isCEP(value):
      return unmaskCEP(value);
    case isCPF(value):
      return unmaskCpf(value);
    case isCNPJ(value):
      return unmaskCnpj(value);
    case !!convertDateString(value):
      return convertDateString(value);
    case isPhone(value):
      return unmaskPhoneNumber(value);
    // case !!unmaskMoney(value):
    //   return unmaskMoney(value);
    default:
      return value;
  }
}
